import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  private subject: BehaviorSubject<string> = new BehaviorSubject<string>('not connected');

  getConnectionStatus(): Observable<string> {
    return this.subject.asObservable();
  }

  updateConnectionStatus(newText: string): void {
    this.subject.next(newText);
  }
}
